/**
 * Reset do carrinho ao sair da Black Friday.
 *
 * Problema: quem navegou na Black (tema preto ativo) pode ter brindes/produtos
 * exclusivos da campanha no carrinho. Quando a campanha acaba (bf_mode = 'off'
 * ou janela encerrada), o black-friday.liquid nem renderiza, então bf-gifts.js
 * e gift-sync.js não carregam e esse brinde fica preso no carrinho — um item que
 * não existe mais na loja normal.
 *
 * Solução: enquanto a Black está ativa para o visitante
 * (window.nutriageBlackFriday.active), marcamos o carrinho como "carrinho da
 * Black". Quando o visitante volta à loja normal (Black inativa) e esse marcador
 * existe, zeramos o carrinho com /cart/clear.js — uma única vez.
 *
 * Carregado sempre pelo theme.liquid (independe do black-friday.liquid), porque
 * justamente quando a campanha está desligada o snippet não roda.
 */
(function () {
  var FLAG_KEY = 'nutriage_bf_cart'; // persiste: carrinho construído durante a Black
  var DONE_KEY = 'nutriage_bf_cart_reset'; // trava por sessão, evita loop de reload

  function readLocal(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }
  function writeLocal(key, value) {
    try {
      if (value === null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, value);
    } catch (e) {}
  }
  function readSession(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }
  function writeSession(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (e) {}
  }

  function run() {
    var bf = window.nutriageBlackFriday;
    var inBlack = Boolean(bf && bf.active);

    // Dentro da Black: só marca o carrinho e encerra.
    if (inBlack) {
      writeLocal(FLAG_KEY, '1');
      return;
    }

    // Loja normal daqui pra frente. Se não há carrinho da Black, nada a fazer.
    if (readLocal(FLAG_KEY) !== '1') return;
    // Já resetamos nesta sessão? Evita reload em loop.
    if (readSession(DONE_KEY) === '1') return;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        // Marca antes de qualquer ação, para nunca repetir o reset nesta sessão.
        writeSession(DONE_KEY, '1');
        writeLocal(FLAG_KEY, null);

        if (!cart || !cart.item_count) return; // carrinho já vazio

        return fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        }).then(function () {
          // Carrinho renderizado no HTML ainda mostra os itens antigos: recarrega
          // para o servidor pintar o carrinho vazio. A trava de sessão impede loop.
          window.location.reload();
        });
      })
      .catch(function (e) {
        console.error('[bf-cart-reset] Falha ao limpar carrinho da Black:', e);
      });
  }

  // window.nutriageBlackFriday é definido por um <script> inline no <head>
  // (black-friday.liquid), que executa antes deste arquivo deferido.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
